/* istanbul ignore file */
import { defineMessages } from 'react-intl'

export default defineMessages({
    requiredProvince: {
        defaultMessage: 'Debes indicar la provincia',
    },
    placeholder: {
        defaultMessage: 'Selecciona una provincia',
    },
    province: {
        defaultMessage: 'Provincia',
    },
})
